export enum EmailStatus {
  Delivered = 0,
  Opened = 1,
  Clicked = 2,
  Failed = 3
}
